import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Quantity from 'components/global/Quantity'
import Price from 'components/shared/Price'
import {
    CreateReservationRoomDto,
    GetCartItemPresenter,
} from 'store/api-slice/hooks'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'
import { DiscountProductInfo } from './style'

export interface DiscountedProductAccommodationProps {
    items: GetCartItemPresenter[]
    totalPrice: number
    lowestPriceLast30Days: number
    totalPriceWithoutDiscount: number
    rooms?: CreateReservationRoomDto[]
}
export const DiscountedProductAccommodation = ({
    items,
    totalPrice,
    lowestPriceLast30Days,
    totalPriceWithoutDiscount,
    rooms,
}: DiscountedProductAccommodationProps) => {
    const { isTablet } = useResolutions()

    const bungalowsList = items.map((item, index) => {
        const { name, description } = item
        if (!name || !rooms) return null

        const { quantity } = rooms[index]

        return new Array(quantity).fill(null).map((_, index) => (
            <Box key={index}>
                <Text variant="body" color="grayscale_900">
                    {name}
                </Text>
                {!!description && (
                    <Text variant="bodySmall" color="grayscale_700">
                        {description}
                    </Text>
                )}
            </Box>
        ))
    })

    return (
        <Box isFullWidth>
            <Box
                direction={isTablet ? 'row' : 'row'}
                justify="space-between"
                isFullWidth
            >
                <Box direction="row" align="flex-start">
                    <Box mr={[8, 16]}>
                        <Quantity value={1} size={isTablet ? 'small' : 'big'} />
                    </Box>
                    <Box direction="column" gap={[10, 8]}>
                        {bungalowsList}
                    </Box>
                </Box>
                <Box align="flex-end">
                    <Price
                        value={totalPrice}
                        color="grayscale_900"
                        size="heading3"
                    ></Price>
                    {!isTablet && (
                        <>
                            <Text
                                variant="bodyExtraSmall"
                                color="grayscale_700"
                                ml={32}
                            >
                                <FormattedMessage
                                    id="order.discount.lowest_price_30_days_info"
                                    defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki:"
                                />{' '}
                                <span>
                                    {formatPrice(lowestPriceLast30Days, true)}
                                </span>
                            </Text>
                            <Text
                                variant="bodyExtraSmall"
                                color="grayscale_700"
                                ml={32}
                            >
                                <FormattedMessage
                                    id="order.discount.regular_price"
                                    defaultMessage="Cena regularna:"
                                />{' '}
                                <span>
                                    {formatPrice(
                                        totalPriceWithoutDiscount,
                                        true
                                    )}
                                </span>
                            </Text>
                        </>
                    )}
                </Box>
            </Box>
            {isTablet && (
                <Box isFullWidth>
                    <DiscountProductInfo
                        isFullWidth
                        align={'flex-end'}
                        alignSelf={'flex-end'}
                        hasNoShrink
                    >
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            ml={32}
                        >
                            <FormattedMessage
                                id="order.discount.regular_price"
                                defaultMessage="Cena regularna:"
                            />{' '}
                            <span>
                                {formatPrice(totalPriceWithoutDiscount, true)}
                            </span>
                        </Text>
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            align={'right'}
                        >
                            <FormattedMessage
                                id="order.discount.lowest_price_30_days_info"
                                defaultMessage="Najniższa cena z 30 dni przed wprowadzeniem obniżki:"
                            />{' '}
                            <span>
                                {formatPrice(lowestPriceLast30Days, true)}
                            </span>
                        </Text>
                    </DiscountProductInfo>
                </Box>
            )}
        </Box>
    )
}
